/**
 * Reusable tabbed list section for admin pages with multiple related resources
 * (e.g. Compliance has Consents + Templates; HLR has Lookups + Batches).
 */
import { useState, type ReactNode } from 'react';

export interface TabSpec {
  id: string;
  label: string;
  render: () => ReactNode;
}

interface Props {
  title: string;
  tabs: TabSpec[];
  defaultTab?: string;
}

export function TabbedListSection({ title, tabs, defaultTab }: Props) {
  const [active, setActive] = useState(defaultTab ?? tabs[0]?.id);
  const current = tabs.find((t) => t.id === active) ?? tabs[0];

  return (
    <section>
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-lg font-semibold">{title}</h2>
        <nav className="flex gap-1 text-sm">
          {tabs.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setActive(t.id)}
              className={[
                'rounded px-3 py-1',
                active === t.id ? 'bg-slate-900 text-white' : 'border bg-white',
              ].join(' ')}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>
      {current ? current.render() : null}
    </section>
  );
}
